import axios from '@/axios';

const RESOURCE_NAME = '/needs-dashboard';

export default {
    getDashboardData() {
        return axios.get(`${RESOURCE_NAME}/get-dashboard-data`);
    },

    sendUpsellRequest(data) {
        return axios.post(`${RESOURCE_NAME}/send-upsell-request`, data)
    },

    getNeedsList(type, filters) {
        return axios.post(`${RESOURCE_NAME}/get-needs-list?type=${type}`, {filters});
    },

    getActivities() {
        return axios.get(`${RESOURCE_NAME}/get-activities`);
    },
}
